// extracted by mini-css-extract-plugin
export default {"container":"request-received_container__0hmNs","greenButton":"request-received_greenButton__qVry9"};